import Vue from 'vue'
import App from './App.vue'
import vueEsign from 'vue-esign'
import { Button,Image,Dialog,Card,Loading,Message } from 'element-ui';
Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Card)
Vue.use(Loading)
Vue.use(vueEsign)
Vue.prototype.$message = Message;
new Vue({
  render: h => h(App),
}).$mount('#app')
